import React from 'react';
import { Card } from './ui/Card';
import { CheckCircle2, Baby, Users, Trophy, Gift } from 'lucide-react';
export function ProductBreakdown() {
  return <section className="py-20 bg-gray-50" id="que-incluye" data-id="element-133">
      <div className="container mx-auto px-4" data-id="element-134">
        <div className="text-center mb-16" data-id="element-135">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 mb-4" data-id="element-136">
            ¿Qué Incluye el <span className="text-pink-600" data-id="element-137">MegaPack</span>?
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-2" data-id="element-138">
            Todo lo que necesitás, dividido por niveles y edades.
          </p>
          <p className="text-base text-pink-600 font-semibold" data-id="element-139">
            📚 Tomos en formato digital PDF
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-140">
          {/* Nivel Inicial */}
          <Card className="flex flex-col h-full hover:shadow-2xl transition-shadow duration-300 border-t-4 border-t-green-500" data-id="element-141">
            <div className="p-8 flex-1 flex flex-col" data-id="element-142">
              <div className="w-full h-48 mb-4 mx-auto flex items-center justify-center rounded-lg bg-green-50" data-id="element-143">
                <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center" data-id="element-144">
                  <Baby className="w-10 h-10 text-green-600" aria-hidden="true" data-id="element-145" />
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center" data-id="element-146">
                Nivel Inicial
              </h3>
              <p className="text-center text-pink-600 font-semibold mb-4" data-id="element-147">
                (3 a 5 años)
              </p>
              <p className="text-gray-600 mb-6 text-center" data-id="element-148">
                Baby Dance y Pre-Danza
              </p>
              <ul className="space-y-3 flex-1" data-id="element-149">
                <li className="flex items-start gap-3" data-id="element-150">
                  <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-151" />
                  <span className="text-gray-700" data-id="element-152">
                    15 Cuentos Motores listos para dar
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-153">
                  <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-154" />
                  <span className="text-gray-700" data-id="element-155">
                    Circuitos psicomotrices con elementos
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-156">
                  <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-157" />
                  <span className="text-gray-700" data-id="element-158">
                    Dinámicas de grupo y ritmo
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-159">
                  <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-160" />
                  <span className="text-gray-700" data-id="element-161">
                    Evaluaciones lúdicas por edad
                  </span>
                </li>
              </ul>
            </div>
          </Card>

          {/* Nivel Primario */}
          <Card className="flex flex-col h-full hover:shadow-2xl transition-shadow duration-300 border-t-4 border-t-blue-600 transform md:-translate-y-4" data-id="element-162">
            <div className="p-8 flex-1 flex flex-col bg-white" data-id="element-163">
              <div className="w-full h-48 mb-4 mx-auto flex items-center justify-center rounded-lg bg-blue-50" data-id="element-164">
                <div className="w-20 h-20 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-165">
                  <Users className="w-10 h-10 text-blue-600" aria-hidden="true" data-id="element-166" />
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center" data-id="element-167">
                Nivel Primario
              </h3>
              <p className="text-center text-pink-600 font-semibold mb-4" data-id="element-168">
                (6 a 12 años)
              </p>
              <p className="text-gray-600 mb-6 text-center" data-id="element-169">
                Técnica e Intermedio
              </p>
              <ul className="space-y-3 flex-1" data-id="element-170">
                <li className="flex items-start gap-3" data-id="element-171">
                  <CheckCircle2 className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-172" />
                  <span className="text-gray-700" data-id="element-173">
                    Planificaciones semanales detalladas
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-174">
                  <CheckCircle2 className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-175" />
                  <span className="text-gray-700" data-id="element-176">
                    20 variaciones de diagonales y saltos
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-177">
                  <CheckCircle2 className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-178" />
                  <span className="text-gray-700" data-id="element-179">
                    Floorwork y técnica progresiva
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-180">
                  <CheckCircle2 className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-181" />
                  <span className="text-gray-700" data-id="element-182">
                    Proyectos coreográficos por trimestre
                  </span>
                </li>
              </ul>
            </div>
          </Card>

          {/* Nivel Avanzado */}
          <Card className="flex flex-col h-full hover:shadow-2xl transition-shadow duration-300 border-t-4 border-t-red-600" data-id="element-183">
            <div className="p-8 flex-1 flex flex-col" data-id="element-184">
              <div className="w-full h-48 mb-4 mx-auto flex items-center justify-center rounded-lg bg-red-50" data-id="element-185">
                <div className="w-20 h-20 rounded-full bg-red-100 flex items-center justify-center" data-id="element-186">
                  <Trophy className="w-10 h-10 text-red-600" aria-hidden="true" data-id="element-187" />
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center" data-id="element-188">
                Nivel Avanzado
              </h3>
              <p className="text-center text-pink-600 font-semibold mb-4" data-id="element-189">
                (13 a 18+ años)
              </p>
              <p className="text-gray-600 mb-6 text-center" data-id="element-190">
                Performance y Maestría
              </p>
              <ul className="space-y-3 flex-1" data-id="element-191">
                <li className="flex items-start gap-3" data-id="element-192">
                  <CheckCircle2 className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-193" />
                  <span className="text-gray-700" data-id="element-194">
                    Entrenamiento físico para bailarines
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-195">
                  <CheckCircle2 className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-196" />
                  <span className="text-gray-700" data-id="element-197">
                    Composición coreográfica avanzada
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-198">
                  <CheckCircle2 className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-199" />
                  <span className="text-gray-700" data-id="element-200">
                    Laboratorio de improvisación
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-201">
                  <CheckCircle2 className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-202" />
                  <span className="text-gray-700" data-id="element-203">
                    Anatomía aplicada y prevención
                  </span>
                </li>
              </ul>
            </div>
          </Card>

          {/* Bonos Exclusivos */}
          <Card className="flex flex-col h-full hover:shadow-2xl transition-shadow duration-300 border-t-4 border-t-pink-600" data-id="element-204">
            <div className="p-8 flex-1 flex flex-col" data-id="element-205">
              <div className="w-full h-48 mb-4 mx-auto flex items-center justify-center rounded-lg bg-pink-50" data-id="element-206">
                <div className="w-20 h-20 rounded-full bg-pink-100 flex items-center justify-center" data-id="element-207">
                  <Gift className="w-10 h-10 text-pink-600" aria-hidden="true" data-id="element-208" />
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center" data-id="element-209">
                Bonos Exclusivos
              </h3>
              <p className="text-center text-pink-600 font-semibold mb-4" data-id="element-210">
                Recursos extra incluidos gratis
              </p>
              <ul className="space-y-3 flex-1" data-id="element-211">
                <li className="flex items-start gap-3" data-id="element-212">
                  <CheckCircle2 className="w-5 h-5 text-pink-600 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-213" />
                  <span className="text-gray-700" data-id="element-214">
                    Kit Muestras Sin Pánico (festival)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-215">
                  <CheckCircle2 className="w-5 h-5 text-pink-600 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-216" />
                  <span className="text-gray-700" data-id="element-217">
                    Generador de Aulas Llenas (marketing)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-218">
                  <CheckCircle2 className="w-5 h-5 text-pink-600 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-219" />
                  <span className="text-gray-700" data-id="element-220">
                    Biblioteca Musical BPM curada
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-221">
                  <CheckCircle2 className="w-5 h-5 text-pink-600 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-222" />
                  <span className="text-gray-700" data-id="element-223">
                    Planillas de asistencia y evaluación
                  </span>
                </li>
              </ul>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}